import { Injectable } from '@angular/core';
import { UserRights } from '@app/models/backend';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  lstUserRights: UserRights[] = [];
  isProfileEditable: boolean = false;
  dashboardInfo: any

  constructor() 
  {
    if (this.lstUserRights.length == 0 )
      this.getUserRights();
  }

  storeUserRight(): void {
    localStorage.setItem("userRights", JSON.stringify(this.lstUserRights));
  }

  getUserRights(): void {
    var tmpUserRights = JSON.parse(localStorage.getItem('userRights')!);
    if (tmpUserRights != null)
      this.lstUserRights = tmpUserRights;
  }

  canUpdate(screenId: number): boolean {
    if (this.lstUserRights.length > screenId)
        if (this.lstUserRights[screenId] != null && this.lstUserRights[screenId].canUpdate)
          return true;
      return false;
  }

  canCreate(screenId: number): boolean {
    if (this.lstUserRights.length > screenId)
        if (this.lstUserRights[screenId] != null && this.lstUserRights[screenId].canCreate)
          return true;
      return false;
  }
}
